"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var forms_1 = require("@angular/forms");
var action_item_directive_1 = require("./actions/action-item.directive");
var actions_component_1 = require("./actions/actions.component");
var actions_service_1 = require("./actions/actions.service");
var app_header_component_1 = require("./app-header/app-header.component");
var button_component_1 = require("./button/button.component");
var button_group_component_1 = require("./button-group/button-group.component");
var card_action_component_1 = require("./card/card-action.component");
var card_body_component_1 = require("./card/card-body.component");
var card_header_component_1 = require("./card/card-header.component");
var card_padding_directive_1 = require("./card/card-padding.directive");
var card_component_1 = require("./card/card.component");
var header_component_1 = require("./header/header.component");
var preloader_component_1 = require("./preloader/preloader.component");
var preloader_directive_1 = require("./preloader/preloader.directive");
var side_menu_item_component_1 = require("./side-menu/side-menu-item.component");
var side_menu_component_1 = require("./side-menu/side-menu.component");
var sidebar_component_1 = require("./sidebar/sidebar.component");
var tab_directive_1 = require("./tabset/tab.directive");
var tab_heading_directive_1 = require("./tabset/tab-heading.directive");
var tabset_component_1 = require("./tabset/tabset.component");
var modal_component_1 = require("./modal/modal.component");
var modal_header_component_1 = require("./modal/modal-header.component");
var modal_body_component_1 = require("./modal/modal-body.component");
var modal_footer_component_1 = require("./modal/modal-footer.component");
var autofocus_directive_1 = require("./modal/autofocus.directive");
var cropped_image_component_1 = require("./cropped-image/cropped-image.component");
var common_2 = require("../common");
var card_action_component_2 = require("./card/card-action.component");
exports.CardActionComponent = card_action_component_2.CardActionComponent;
var card_body_component_2 = require("./card/card-body.component");
exports.CardBodyComponent = card_body_component_2.CardBodyComponent;
var card_header_component_2 = require("./card/card-header.component");
exports.CardHeaderComponent = card_header_component_2.CardHeaderComponent;
var card_padding_directive_2 = require("./card/card-padding.directive");
exports.CardPaddingDirective = card_padding_directive_2.CardPaddingDirective;
var card_component_2 = require("./card/card.component");
exports.CardComponent = card_component_2.CardComponent;
var header_component_2 = require("./header/header.component");
exports.HeaderComponent = header_component_2.HeaderComponent;
var preloader_component_2 = require("./preloader/preloader.component");
exports.PreloaderComponent = preloader_component_2.PreloaderComponent;
var preloader_directive_2 = require("./preloader/preloader.directive");
exports.PreLoaderDirective = preloader_directive_2.PreLoaderDirective;
var side_menu_item_component_2 = require("./side-menu/side-menu-item.component");
exports.SideMenuItemComponent = side_menu_item_component_2.SideMenuItemComponent;
var side_menu_component_2 = require("./side-menu/side-menu.component");
exports.SideMenuComponent = side_menu_component_2.SideMenuComponent;
var sidebar_component_2 = require("./sidebar/sidebar.component");
exports.SidebarComponent = sidebar_component_2.SidebarComponent;
var tab_directive_2 = require("./tabset/tab.directive");
exports.TabDirective = tab_directive_2.TabDirective;
var tab_heading_directive_2 = require("./tabset/tab-heading.directive");
exports.TabHeadingDirective = tab_heading_directive_2.TabHeadingDirective;
var tabset_component_2 = require("./tabset/tabset.component");
exports.TabsetComponent = tabset_component_2.TabsetComponent;
var modal_component_2 = require("./modal/modal.component");
exports.ModalComponent = modal_component_2.ModalComponent;
var modal_header_component_2 = require("./modal/modal-header.component");
exports.ModalHeaderComponent = modal_header_component_2.ModalHeaderComponent;
var modal_body_component_2 = require("./modal/modal-body.component");
exports.ModalBodyComponent = modal_body_component_2.ModalBodyComponent;
var modal_footer_component_2 = require("./modal/modal-footer.component");
exports.ModalFooterComponent = modal_footer_component_2.ModalFooterComponent;
var autofocus_directive_2 = require("./modal/autofocus.directive");
exports.AutofocusDirective = autofocus_directive_2.AutofocusDirective;
var cropped_image_component_2 = require("./cropped-image/cropped-image.component");
exports.CroppedImageComponent = cropped_image_component_2.CroppedImageComponent;
var common_3 = require("../common");
exports.NgTranscludeDirective = common_3.NgTranscludeDirective;
var MaterialUserInterfaceModule = (function () {
    function MaterialUserInterfaceModule() {
    }
    return MaterialUserInterfaceModule;
}());
MaterialUserInterfaceModule = __decorate([
    core_1.NgModule({
        imports: [
            common_1.CommonModule,
            forms_1.ReactiveFormsModule,
        ],
        declarations: [
            common_2.NgTranscludeDirective,
            action_item_directive_1.ActionItemDirective,
            actions_component_1.ActionsComponent,
            app_header_component_1.AppHeaderComponent,
            button_component_1.ButtonComponent,
            button_group_component_1.ButtonGroupComponent,
            card_action_component_1.CardActionComponent,
            card_body_component_1.CardBodyComponent,
            card_header_component_1.CardHeaderComponent,
            card_padding_directive_1.CardPaddingDirective,
            card_component_1.CardComponent,
            header_component_1.HeaderComponent,
            preloader_component_1.PreloaderComponent,
            preloader_directive_1.PreLoaderDirective,
            side_menu_item_component_1.SideMenuItemComponent,
            side_menu_component_1.SideMenuComponent,
            sidebar_component_1.SidebarComponent,
            tab_directive_1.TabDirective,
            tab_heading_directive_1.TabHeadingDirective,
            tabset_component_1.TabsetComponent,
            modal_component_1.ModalComponent,
            modal_header_component_1.ModalHeaderComponent,
            modal_body_component_1.ModalBodyComponent,
            modal_footer_component_1.ModalFooterComponent,
            autofocus_directive_1.AutofocusDirective,
            cropped_image_component_1.CroppedImageComponent,
        ],
        exports: [
            action_item_directive_1.ActionItemDirective,
            actions_component_1.ActionsComponent,
            app_header_component_1.AppHeaderComponent,
            button_component_1.ButtonComponent,
            button_group_component_1.ButtonGroupComponent,
            card_action_component_1.CardActionComponent,
            card_body_component_1.CardBodyComponent,
            card_header_component_1.CardHeaderComponent,
            card_padding_directive_1.CardPaddingDirective,
            card_component_1.CardComponent,
            header_component_1.HeaderComponent,
            preloader_component_1.PreloaderComponent,
            preloader_directive_1.PreLoaderDirective,
            side_menu_item_component_1.SideMenuItemComponent,
            side_menu_component_1.SideMenuComponent,
            sidebar_component_1.SidebarComponent,
            tab_directive_1.TabDirective,
            tab_heading_directive_1.TabHeadingDirective,
            tabset_component_1.TabsetComponent,
            modal_component_1.ModalComponent,
            modal_header_component_1.ModalHeaderComponent,
            modal_body_component_1.ModalBodyComponent,
            modal_footer_component_1.ModalFooterComponent,
            autofocus_directive_1.AutofocusDirective,
            cropped_image_component_1.CroppedImageComponent,
        ],
        providers: [
            actions_service_1.ActionsService,
        ],
    }),
    __metadata("design:paramtypes", [])
], MaterialUserInterfaceModule);
exports.MaterialUserInterfaceModule = MaterialUserInterfaceModule;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-material-components/user-interface/material-user-interface.module.js
// module id = 72
// module chunks = 0